import { gql } from "graphql-tag";

export const GET_SUBSCRIPTIONS_ALL = gql`
  query subscriptionsAll($includeArchived: Boolean, $activeOnly: Boolean) {
    subscriptionsAll(includeArchived: $includeArchived, activeOnly: $activeOnly) {
      id
      propertyInterestListId
      planId
      pricingId
      billingFrequencyId
      startDate
      endDate
      renewalDate
      insertedAt
      updatedAt
      propertyInterestList {
        id
        propertyId
        interestListId
        property {
          id
          name
          units
          organization {
            id
            name
          }
        }
        interestList {
          id
          name
        }
      }
      plan {
        id
        name
      }
      pricing {
        id
        pricingType {
          name
        }
        minimumPrice
        unitThreshold
      }
      billingFrequency {
        id
        name
      }
      monthlyRecurringRevenue
      invoicedId
      propertyContract {
        id
        propertyName
        status
      }
    }
  }
`;

export const GET_SUBSCRIPTION_BY_ID = gql`
  query subscriptionById($id: ID!) {
    subscriptionById(id: $id) {
      id
      propertyInterestListId
      planId
      pricingId
      billingFrequencyId
      startDate
      endDate
      renewalDate
      insertedAt
      updatedAt
      invoicedId
      propertyContract {
        id
        propertyName
        status
      }
      propertyInterestList {
        id
        propertyId
        interestListId
        property {
          id
          name
          organization {
            name
          }
        }
        interestList {
          id
          name
          organization {
            name
          }
        }
      }
      plan {
        id
        name
      }
      pricing {
        id
      }
      billingFrequency {
        id
        name
      }
    }
  }
`;

export const CREATE_SUBSCRIPTION = gql`
  mutation createSubscription($data: SubscriptionInput!) {
    createSubscription(data: $data) {
      id
      propertyInterestListId
      planId
      pricingId
      billingFrequencyId
      propertyInterestList {
        id
        property {
          id
          name
        }
        interestList {
          id
          name
        }
      }
      plan {
        id
        name
      }
      pricing {
        id
      }
      billingFrequency {
        id
        name
      }
    }
  }
`;

export const UPDATE_SUBSCRIPTION = gql`
  mutation updateSubscription($id: ID!, $data: SubscriptionUpdateInput!) {
    updateSubscription(id: $id, data: $data) {
      id
      propertyInterestListId
      planId
      pricingId
      billingFrequencyId
      propertyInterestList {
        id
        property {
          id
          name
        }
        interestList {
          id
          name
        }
      }
      plan {
        id
        name
      }
      pricing {
        id
      }
      billingFrequency {
        id
        name
      }
    }
  }
`;

export const ARCHIVE_SUBSCRIPTION = gql`
  mutation archiveSubscription($id: ID!) {
    archiveSubscription(id: $id) {
      id
    }
  }
`;

export const SET_SUBSCRIPTION_INVOICED_ID = gql`
  mutation setSubscriptionInvoicedId($id: ID!, $invoicedId: TrimmedId!) {
    setSubscriptionInvoicedId(id: $id, invoicedId: $invoicedId) {
      id
      invoicedId
    }
  }
`;

export const GET_PROPERTIES_FOR_SUBSCRIPTIONS = gql`
  query getAllPropertiesForSubscriptions($includeArchived: Boolean) {
    properties(includeArchived: $includeArchived) {
      id
      name
      organization {
        name
      }
    }
  }
`;

export const GET_INTEREST_LISTS_FOR_SUBSCRIPTIONS = gql`
  query getInterestListsForSubscriptions($includeArchived: Boolean) {
    interestLists(includeArchived: $includeArchived) {
      id
      name
      organization {
        id
        name
      }
    }
  }
`;

export const GET_PLANS_FOR_SUBSCRIPTIONS = gql`
  query plansAllForSubscriptions {
    plansAll {
      id
      name
    }
  }
`;

export const GET_PRICING_FOR_SUBSCRIPTIONS = gql`
  query pricingAllForSubscriptions {
    pricingAll {
      id
      pricingTypeId
      thresholdTypeId
      minimumPrice
      unitThreshold
      monthlyPricePerUnit
      pricingType {
        id
        name
      }
      thresholdType {
        id
        name
      }
    }
  }
`;

export const GET_FREQUENCIES = gql`
  query frequenciesAll {
    frequenciesAll {
      id
      name
    }
  }
`;
